export default {
    imageAIFormRules: {
        enterDescription: 'Forneça a descrição',
        invalidDescription: 'Forneça uma descrição válida',
        enterNumberOfVariations: 'Selecione o número de variações',
        invalidNumberOfVariations: 'Você pode gerar no máximo 4 e no mínimo 1 variação',
        enterStyle: 'Por favor, selecione pelo menos um estilo',
    },
};
